<template>
  <async-multi-select
    :value="value"
    single
    :items="customers"
    :search="fetchCustomers"
    label="Гость — поиск по номеру телефона"
    @input="$emit('input', $event)"
  ></async-multi-select>
</template>

<script>
import notificationSettingApi from '@/api/notification-setting'
import AsyncMultiSelect from '@/components/async-multi-select'

export default {
  name: 'TestCustomerSelect',
  components: { AsyncMultiSelect },

  props: {
    value: null,
  },
  data: () => ({
    customers: [],
  }),
  methods: {
    async fetchCustomers(params) {
      const { data } = await notificationSettingApi.getTestPushCustomers(params)

      this.customers = data.map(x => ({ text: x.name, value: x.id }))
    },
  },
}
</script>
